var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cookies", style: _vm.cssProps, on: { open: _vm.open } },
    [
      _vm.cookieBarVisible
        ? _c("div", { staticClass: "cookie-container" }, [
            _vm.settings
              ? _c("div", [
                  _vm.settings
                    ? _c(
                        "div",
                        { staticClass: "cookies2022_settings_screen" },
                        [
                          _c("div", { staticClass: "cookies2022_text" }, [
                            _c("h5", {
                              domProps: {
                                textContent: _vm._s(_vm.text.settings_heading)
                              }
                            }),
                            _c("p", {
                              domProps: {
                                textContent: _vm._s(_vm.text.settings_text)
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "cookies2022_allow_action" },
                              [
                                _c("button", {
                                  staticClass: "btn btn-action btn-default",
                                  domProps: {
                                    textContent: _vm._s(_vm.text.allow_all)
                                  },
                                  on: { click: _vm.allowAll }
                                })
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "cookies2022_settings" }, [
                            _c(
                              "div",
                              { staticClass: "cookies2022_settings--row" },
                              [
                                _c("v-switch", {
                                  attrs: {
                                    "input-value": "true",
                                    disabled: "",
                                    label: _vm.text.basic
                                  }
                                }),
                                _c("p", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.text.basic_description
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "cookies2022_settings--row" },
                              [
                                _c("v-switch", {
                                  attrs: { label: _vm.text.marketing },
                                  model: {
                                    value: _vm.marketingCookiesEnabled,
                                    callback: function($$v) {
                                      _vm.marketingCookiesEnabled = $$v
                                    },
                                    expression: "marketingCookiesEnabled"
                                  }
                                }),
                                _c("p", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.text.marketing_description
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "cookies2022_settings--row" },
                              [
                                _c("v-switch", {
                                  attrs: { label: _vm.text.analytical },
                                  model: {
                                    value: _vm.analyticalCookiesEnabled,
                                    callback: function($$v) {
                                      _vm.analyticalCookiesEnabled = $$v
                                    },
                                    expression: "analyticalCookiesEnabled"
                                  }
                                }),
                                _c("p", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.text.analytical_description
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "cookies2022_actions" }, [
                    _c("button", {
                      staticClass: "btn btn-action btn-default",
                      domProps: { textContent: _vm._s(_vm.text.save) },
                      on: { click: _vm.close }
                    })
                  ])
                ])
              : _c("div", [
                  _c("div", { staticClass: "text-content" }, [
                    _c("h5", {
                      domProps: { textContent: _vm._s(_vm.text.heading) }
                    }),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(" " + _vm._s(_vm.text.text) + ' "'),
                      _c("a", {
                        attrs: { href: "#" },
                        domProps: {
                          textContent: _vm._s(_vm.text.change_settings)
                        },
                        on: {
                          click: function($event) {
                            _vm.settings = 1
                          }
                        }
                      }),
                      _vm._v('". ')
                    ])
                  ]),
                  _c("div", { staticClass: "cookies2022_actions" }, [
                    _c("button", {
                      staticClass: "btn btn-ghost",
                      domProps: {
                        textContent: _vm._s(_vm.text.change_settings)
                      },
                      on: {
                        click: function($event) {
                          _vm.settings = true
                        }
                      }
                    }),
                    _c("button", {
                      staticClass: "btn btn-action btn-default",
                      domProps: { textContent: _vm._s(_vm.text.accept_all) },
                      on: { click: _vm.allowAll }
                    })
                  ])
                ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }